module.exports = __webpack_public_path__ + "cabb1c2bb21cdf80b4af7ea14eb35c68.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/whats-new-sidemenu/whats-new-sidemenu.html
// module id = 2203
// module chunks = 0